import { useQuery } from 'hooks/useCustomQuery';
import getTriggerEvents from 'API/Triggers/getTriggerEvents';
import { toast } from 'react-toastify';

const useGetTriggerEvents = (setTriggerEvents, scope) => {
    return useQuery({
        queryKey: ['triggerEvents', scope],
        queryFn: async () => {
            try {
                const data = await getTriggerEvents(scope);
                if (setTriggerEvents) {
                    setTriggerEvents(data);
                }
                return data;
            } catch (error) {
                const errorMessage = `Failed to get trigger events: ${error}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
        enabled: !!setTriggerEvents && scope !== undefined,
        staleTime: 0,
    });
};

export default useGetTriggerEvents;
